import React from 'react'
import { SvgIconProps } from './Home'

const SvgVisibilityIcon = ({ fill, width, height }: SvgIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "17"}
      height={height ?? "17"}
      fill="none"
      viewBox="0 0 17 17"
    >
      <path
        fill={fill ?? "#353535"}
        d="M8.333 4.167A7.209 7.209 0 0114.875 8.4a7.175 7.175 0 01-13.083 0 7.208 7.208 0 016.541-4.233zm0-1.667A8.85 8.85 0 000 8.4a8.833 8.833 0 0016.667 0 8.85 8.85 0 00-8.334-5.9z"
      ></path>
      <path
        fill={fill ?? "#353535"}
        d="M9.792 7.717a1.117 1.117 0 01-1.109-1.109 1.092 1.092 0 01.434-.833A2.867 2.867 0 007.95 5.5a2.95 2.95 0 102.708 1.783 1.091 1.091 0 01-.866.434z"
      ></path>
    </svg>
  )

export default SvgVisibilityIcon
